import { ReduxStore } from 'store/types';

function createPasswordIsLoading(state: ReduxStore): boolean {
  return state.auth.createPassword.config.isLoading;
}

export default createPasswordIsLoading;
